/*
  Landing page sticky button (sections/movitamins-lp-hero.liquid). Shows once the hero's buy row has scrolled
  out of view above the screen, and hides again while an offer section or another landing page button is in
  view, so there is never a second button right next to the one on the page.
*/
if (!customElements.get('movitamins-lp-sticky')) {
  customElements.define(
    'movitamins-lp-sticky',
    class MovitaminsLpSticky extends HTMLElement {
      connectedCallback() {
        const hero = this.closest('.shopify-section')?.querySelector('.mvlp-buy');
        if (!hero || !('IntersectionObserver' in window)) return;
        this.heroAbove = false;
        this.offersInView = new Set();

        this.heroObserver = new IntersectionObserver(([entry]) => {
          this.heroAbove = !entry.isIntersecting && entry.boundingClientRect.top < 0;
          this.update();
        });
        this.heroObserver.observe(hero);

        this.offerObserver = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) this.offersInView.add(entry.target);
            else this.offersInView.delete(entry.target);
          });
          this.update();
        });
        document
          .querySelectorAll('.mvlp-offer, .mvlp:not(.mvlp-hero):not(.mvlp-sticky) .mvlp__button')
          .forEach((element) => this.offerObserver.observe(element));
      }

      disconnectedCallback() {
        this.heroObserver?.disconnect();
        this.offerObserver?.disconnect();
      }

      update() {
        const visible = this.heroAbove && this.offersInView.size === 0;
        this.classList.toggle('is-visible', visible);
        this.toggleAttribute('inert', !visible);
        this.setAttribute('aria-hidden', String(!visible));
      }
    }
  );
}
